import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { formatDate } from '../../lib/utils';
import { Clock, RefreshCw } from 'lucide-react';

export default function AdminExpiring({ 
  expiringCerts, 
  onRenew 
}) {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Declarations Expiring in 30 Days
        </h2>
        <p className="text-sm text-zinc-500 mt-1">These declarations need attention for renewal.</p>
      </div>
      {expiringCerts.length === 0 ? (
        <div className="text-center py-12 border border-zinc-200">
          <Clock className="w-12 h-12 mx-auto text-zinc-300 mb-4" />
          <p className="text-zinc-500">No declarations expiring in the next 30 days.</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Days Left</th>
                <th>Declaration ID</th>
                <th>Organization</th>
                <th>Standard</th>
                <th>Expiry Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {expiringCerts.map(cert => (
                <tr key={cert.id} className={cert.days_until_expiry <= 7 ? 'bg-red-50' : cert.days_until_expiry <= 14 ? 'bg-amber-50' : ''}>
                  <td>
                    <Badge variant="outline" className={`rounded-none ${cert.days_until_expiry <= 7 ? 'bg-red-100 text-red-800 border-red-200' : 'bg-amber-100 text-amber-800 border-amber-200'}`}>
                      {cert.days_until_expiry} days
                    </Badge>
                  </td>
                  <td className="cert-id">{cert.declaration_id}</td>
                  <td>{cert.org_name}</td>
                  <td>{cert.standard_title}</td>
                  <td>{formatDate(cert.expiry_date)}</td>
                  <td>
                    <Button variant="ghost" size="sm" onClick={() => onRenew(cert.id)} className="text-emerald-600" data-testid={`renew-expiring-${cert.id}`}>
                      <RefreshCw className="w-4 h-4 mr-1" />
                      Renew Now
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
